export default "__VITE_ASSET__D5I88YWm__"